import { Link } from "react-router-dom";
import styled from "styled-components";

/*
 * The clickable regions of every tense map are invisible paths laid over the
 * drawing (fill-opacity 0), so the hover treatment is the only thing telling a
 * visitor that an area can be opened. It used to be a flat `fill: red`, which
 * read as a rendering glitch on top of the beige diagram; this is a brand
 * orange wash with an outline, a soft glow, and the same feedback for keyboard
 * focus so the hotspots are reachable without a mouse.
 */
export const LinkMap = styled(Link)`
  cursor: pointer;

  > path {
    transition: fill 0.25s ease, fill-opacity 0.25s ease, stroke 0.25s ease,
      stroke-width 0.25s ease, filter 0.25s ease;
  }

  > path:hover {
    fill: #f97316;
    fill-opacity: 0.22;
    stroke: #f97316;
    stroke-width: 2px;
    filter: drop-shadow(0 0 6px rgba(249, 115, 22, 0.55));
  }

  &:focus-visible > path {
    fill: #f97316;
    fill-opacity: 0.22;
    stroke: #f97316;
    stroke-width: 2px;
  }
`;